export type InvalidUserFieldKey =
  | 'name'
  | 'email'
  | 'phone'
  | 'role'
  | 'alertNotificationType'
  | 'groupName'
  | 'teamName'
  | 'sendInvite';

type PreviewIssueLike = {
  code: string;
  fields?: string[];
};

const allowedFields = new Set<InvalidUserFieldKey>([
  'name',
  'email',
  'phone',
  'role',
  'alertNotificationType',
  'groupName',
  'teamName',
  'sendInvite',
]);

export const highlightedFieldsForError = (error: PreviewIssueLike): InvalidUserFieldKey[] => {
  const fields = (error.fields || [])
    .filter((field): field is InvalidUserFieldKey => allowedFields.has(field as InvalidUserFieldKey));

  if (fields.length > 0) {
    return Array.from(new Set(fields));
  }

  // Safe fallback for older payloads: highlight the whole row identity instead of parsing message text.
  return ['email'];
};
